export const WHATSAPP = {
  CHAT_URI: 'https://api.whatsapp.com/send?phone=56946853644',
};